import React, { useState, useEffect } from "react";
import axios from "axios";
import { base_url } from "../../../config";

const SuccessModal = ({ id, onClose, preview }) => {
  const [tableData, setTableData] = useState(null);

  const fetchDatanotoken = async () => {
    try {
      const response = await axios.get(`${base_url}/tables/view`, {
        params: { id },
        headers: { "Content-Type": "application/json" },
      });
      setTableData(response.data.details);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDatanotoken();
  }, [id]);

  if (!tableData) {
    return null; // Don't render if data isn't available yet
  }

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50 ">
      <div className="bg-white w-[90%] md:w-[400px] p-6 rounded-2xl shadow-lg relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 text-xl font-bold"
        >
          ✕
        </button>

        {/* Success Message */}
        <div className="text-center mb-4">
          <h2 className="text-sm md:text-lg font-semibold text-black">
            Yay! Your table request is in. Sit back and relax—you'll be notified
            once it's approved!
          </h2>
        </div>

        {/* Table Details */}
        <div className="rounded-xl overflow-hidden shadow-lg">
          <img src={preview} alt="Table" className="w-full h-40 object-cover" />
        </div>

        <div className="mt-3">
          <p className="text-gray-500 text-sm">{tableData.event_date}</p>
          <h3 className="text-lg font-semibold">{tableData.title}</h3>
          <p className="text-gray-700">{tableData.address}</p>
        </div>

        {/* Creator Details */}
        <div className="mt-4 flex items-center gap-3">
          <img
            src={localStorage.getItem("@userPhoto")}
            alt={tableData.creator_details.first_name}
            className="w-10 h-10 rounded-full object-cover"
          />
          <span className="text-gray-700 font-medium">
            {tableData.creator_details.first_name}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
